export const isSessionStorageAvailable = (): boolean => {
  try {
    window.sessionStorage;
  } catch {
    return false;
  }

  return true;
};
